import React, { useState } from 'react'
import { sleep } from '~common/utils/sleep'
import { Button } from '~common/components/button'

export type SortDirection = 'asc' | 'desc'

export interface SortIndicatorProps {
    initialDirection?: 'asc' | 'desc'
    onSortChange?: (direction: 'asc' | 'desc') => void
    className?: string
    variant?: 'ghost' | 'glass'
}

export function SortIndicator({
    initialDirection = 'asc',
    variant = 'ghost',
    onSortChange,
    className,
}: SortIndicatorProps) {
    const [direction, setDirection] = useState<'asc' | 'desc'>(initialDirection)

    const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
        const newDirection = direction === 'asc' ? 'desc' : 'asc'
        setDirection(newDirection)
        await sleep(100)
        onSortChange?.(newDirection)
        event.stopPropagation()
        event.preventDefault()
    }

    return (
        <Button
            onClick={handleClick}
            size="small"
            borderRadius="full"
            status="info"
            variant={'glass'}
            icon={direction === 'asc' ? 'arrow-up' : 'arrow-down'}
            tabIndex={-1}
        />
    )
}
